export const formatMatchPartsResult = (match) => {
    if (!match.partResults) {
        return null;
    }
    return match.partResults.map(part => {
        let walkoverA, walkoverB;
        walkoverA = part.winByWalkoverA ? ' (WO)' : '';
        walkoverB = part.winByWalkoverB ? ' (WO)' : '';

        return `${part.sideA}${walkoverA}-${part.sideB}${walkoverB}`;
    }).join(', ');
};
export const formatMatchResult = (match) => {
    if (!match.score) {
        return null;
    }
    return `${match.score.sideA} : ${match.score.sideB}`
};